import React, { FC, useState } from 'react';
import { useIntl }             from 'react-intl';

import Snackbar       from '@material-ui/core/Snackbar';
import { useCookies } from "react-cookie";

export interface CookieConsentBannerProps {

}

export const CookieConsentBanner: FC<CookieConsentBannerProps> = () => {

    const [ bannerOpen, setBannerOpen ] = useState<boolean>(false);
    const [ cookies, setCookie, removeCookie]  = useCookies();

    const intl = useIntl();

    return (<>
        <Snackbar
            open={bannerOpen}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            title={'Test'}
            color={'primary'}
            message={<div>// Cookie Consent here.<br/>Another Line</div>}
            action={<>
                Some Actions
                </>}
        />
        </>);
}